<div cdkDropListGroup fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
  <div class="container" fxFlex.gt-md="50" fxFlex.sm="100" fxFlex.xs="100">
    <h2>{{list?.length}} Unallocated UNU-Keys</h2>
    <div cdkDropList class="list"
         id="unuKeys"
         [cdkDropListConnectedTo]="['dropBoxes']"
         [cdkDropListData]="list"
         (cdkDropListDropped)="drop($event)">
      <div *ngFor="let item of list" cdkDrag class="box" matTooltip="{{item?.comment}}">{{item.description}}</div>
    </div>
  </div>

  <div class="container" fxFlex.gt-md="50" fxFlex.sm="100" fxFlex.xs="100">
    <h2>{{unallocatedSets}} Unallocated {{titleDropBoxes}}</h2>
    <mat-expansion-panel cdkDropList class="list drop-list"
                         *ngFor="let category of dropBoxes; let i = index" [attr.data-index]="i"
                         id="dropBoxes"
                         [cdkDropListConnectedTo]="['unuKeys']"
                         [cdkDropListData]="mappings[i]"
                         (cdkDropListDropped)="drop($event)">
      <mat-expansion-panel-header class="drop-list-title" matTooltip="{{category?.comment}}">
        <strong>{{category.description.toUpperCase()}}  ({{mappings[i]?.length || 0}})</strong>
      </mat-expansion-panel-header>
      <div *ngFor="let item of mappings[i]" cdkDrag class="box" matTooltip="{{item?.comment}}">
        {{item.description}}
      </div>
    </mat-expansion-panel>
  </div>


</div>
<div class="wizard-buttons-container align-right">
  <button mat-raised-button matStepperPrevious (click)="previousStep.emit()">
    <mat-icon class="material-icons-outlined">chevron_left</mat-icon>
    <span>Back</span>
  </button>
  <button mat-raised-button color="primary" (click)="save()">
    <span>Save & Next</span>
    <mat-icon class="material-icons-outlined">chevron_right</mat-icon>
  </button>
</div>
